<script setup>
const props = defineProps({
  disabled: Boolean
})

const emit = defineEmits(['click'])

const onClick = (e) => {
  if (props.disabled) {
    return
  }
  emit('click', e)
}
</script>
<template>
  <button v-bind="$attrs" :disabled="props.disabled" @click="onClick">
    <slot />
  </button>
</template>
